import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { CloseOutlined, RedoOutlined } from "@ant-design/icons";
import { Tabs, message } from "antd";

import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import Loading from "components/App/Loading";
import FinishButton from "components/Modals/AdminManageOrder/FinishButton";
import CheckDetailsButton from "components/Modals/AdminManageOrder/CheckDetailsButton";
import Table from "components/Tables/Table";
import { getUserState } from "state/selector";
import { states } from "constants/app";

function Index() {
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState(false);
  const [status, setStatus] = useState("[0,1]");

  useEffect(() => {
    Fetch.post(`/orders/status`, { list: JSON.parse(status) }, (res) => {
      if (res) {
        setOrders(res);
        setData(res);
        setReload(false);
      }
    });
  }, [reload]);

  function handleCancelStatus(id) {
    let confirm = window.prompt(
      "اگر از لغو این سفارش اطمینان دارید کلمه (لغو) را وارد کنید"
    );
    if (confirm !== "لغو") return;

    Fetch.put(`/orders/${id}`, { status: 4 }, (res) => {
      console.log("%c finish product response", "background: blue;", res);
      if (res) {
        message.success("با موفقیت انجام شد");
      } else {
        message.error("خطایی رخ داده است");
      }

      setReload((e) => !e);
    });
  }
  function handleReload() {
    setReload(true);
  }
  function handleTabChange(key) {
    setStatus(key);
    handleReload();
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <Container>
      {/* <code>
        public function autocomplete(Request $request)
        {` $res = Product::select("name")
                ->where("name","LIKE","%{$request->term}%")
                ->get();
    
        return response()->json($res);`}
      </code>
      <br />
      <code>autocomplete input component</code>
      <br />
      <a href="https://www.tutsmake.com/laravel-8-autocomplete-search-from-database-tutorial/">
        <code>
          https://www.tutsmake.com/laravel-8-autocomplete-search-from-database-tutorial/
        </code>
      </a> */}
      {/* <CardsContainer>
        <StatusCard
          color={colors.secondary}
          textColor="#444"
          value={orders.filter((item) => item.state === 0).length}
          text="در حال پردازش"
          link=""
        />
        <StatusCard
          color="#3A4041"
          textColor="#fff"
          value="0000"
          text="در انتظار ارسال"
          link=""
        />
        <StatusCard
          color="#E8E8E8"
          textColor="#444"
          value={orders.filter((item) => item.stock === 0).length}
          text="کالا های بدون موجودی"
          link=""
        />
      </CardsContainer> */}
      <Button
        style={{ marginBottom: 16, marginRight: -6 }}
        onClick={handleReload}
      >
        <RedoOutlined /> بارگذاری مجدد
      </Button>
      <Tabs defaultActiveKey="active" onChange={handleTabChange}>
        <Tabs.TabPane tab="فعال" key="[0,1]"></Tabs.TabPane>
        <Tabs.TabPane tab="ارسال شده" key="[2]"></Tabs.TabPane>
        <Tabs.TabPane tab="مرجوع شده" key="[3]"></Tabs.TabPane>
        <Tabs.TabPane tab="لغو شده" key="[4]"></Tabs.TabPane>
        <Tabs.TabPane tab="همه" key="[0,1,2,3,4]"></Tabs.TabPane>
      </Tabs>
      <TableContainer>
        <Table
          loading={reload}
          columns={tableHeaders}
          dataSource={
            orders?.length &&
            orders?.map((item, index) => ({
              address: `${JSON.parse(item.shipment_address)?.province}-${
                JSON.parse(item.shipment_address)?.city
              }`,
              price: (
                <span>
                  {(Number(item.order_price) / 10).toLocaleString()} تومان
                </span>
              ),
              status: (
                <span className="status">
                  {states[item.status].icon} {states[item.status].title}
                </span>
              ),
              shipment_type:
                item.shipment_type === "1"
                  ? "پست"
                  : item.shipment_type === "2"
                  ? "تیپاکس"
                  : "باربری",
              actions:
                item.status === 0 ? (
                  <div className="center row">
                    <FinishButton data={item} reload={setReload} />
                    <Button
                      style={{ marginRight: 6 }}
                      color="red"
                      onClick={() => handleCancelStatus(item.id)}
                    >
                      <CloseOutlined />
                    </Button>
                  </div>
                ) : (
                  <div className="center">
                    <CheckDetailsButton data={item} reload={setReload} />
                  </div>
                ),
              key: item.id,
            }))
          }
        />
      </TableContainer>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const user = getUserState(state);
  return { user };
};
export default connect(mapStateToProps)(Index);
const Container = styled.div`
  color: ${colors.dark};

  & .status {
    display: inline-flex;
    align-items: center;
    > div {
      height: 24px;
    }
  }
`;
const TableContainer = styled.div``;
const tableHeaders = [
  {
    title: "کد",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "مبلغ",
    dataIndex: "price",
    key: "price",
    align: "center",
  },
  { title: "آدرس", dataIndex: "address", key: "address", align: "center" },
  {
    title: "ارسال",
    dataIndex: "shipment_type",
    key: "shipment_type",
    align: "center",
  },
  { title: "مرحله", dataIndex: "status", key: "status", align: "center" },
  { title: "اعمال", dataIndex: "actions", key: "actions", align: "center" },
];
